import React, { createContext, useCallback, useReducer } from 'react';
import { ACTIONS } from 'utils/constants';

let initialState = {
    accountNbr: '',
    delegateId: '',
    tempPin: '',
    policyTerms: [],
    firstNm: '',
    lastNm: '',
    jobTitleTxt: '',
    businessNm: '',
    phoneNbr: '',
    phoneTypeCd: '',
    businessRelationshipTypeCd: '',
    userId: '',
    passwordTxt: '',
    emailAddressTxt: '',
    securityQuestions: null
};

if (window.localStorage.getItem('globalProviderInitalState')) {
    initialState = JSON.parse(window.localStorage.getItem('globalProviderInitalState'));
}

const GlobalContext = createContext(initialState);

const GlobalReducer = (state, action) => {
    const { type, acctInfo, contactInfo, passwordInfo, hasError, error } = action;
    switch (type) {
        case ACTIONS.UPDATE_ACCT_INFO: {
            const { accountNbr, delegateId, policyTerms, tempPin } = acctInfo;
            return { ...state, accountNbr, delegateId, policyTerms, tempPin };
        }
        case ACTIONS.RESET_STATE:
            return initialState;
        case ACTIONS.SHOW_ERROR:
            return { ...state, hasError, error };
        case ACTIONS.UPDATE_CONTACT_INFO: {
            const {
                firstNm,
                lastNm,
                emailAddressTxt,
                jobTitleTxt,
                phoneNbr,
                phoneTypeCd,
                businessRelationshipTypeCd,
                businessNm
            } = contactInfo;
            return {
                ...state,
                firstNm,
                lastNm,
                emailAddressTxt,
                jobTitleTxt,
                phoneNbr,
                phoneTypeCd,
                businessRelationshipTypeCd,
                businessNm
            };
        }
        case ACTIONS.UPDATE_PASSWORD_INFO: {
            const { userId, passwordTxt, securityQuestions } = passwordInfo;
            return { ...state, userId, passwordTxt, securityQuestions };
        }
        default:
            return state;
    }
};

const GlobalProvider = ({ children }) => {
    const [state, dispatch] = useReducer(GlobalReducer, initialState);
    const actions = {
        updateAcctInfo: useCallback(
            acctInfo => {
                dispatch({
                    type: ACTIONS.UPDATE_ACCT_INFO,
                    acctInfo
                });
            },
            [dispatch]
        ),
        resetState: useCallback(() => {
            dispatch({
                type: ACTIONS.RESET_STATE
            });
        }, [dispatch]),
        throwError: useCallback(
            (type, error) => {
                dispatch({
                    type: ACTIONS.SHOW_ERROR,
                    hasError: true,
                    error: { type, error: error.message }
                });
            },
            [dispatch]
        ),
        updateContactInfo: useCallback(
            contactInfo => {
                dispatch({
                    type: ACTIONS.UPDATE_CONTACT_INFO,
                    contactInfo
                });
            },
            [dispatch]
        ),
        updatePasswordInfo: useCallback(
            passwordInfo => {
                dispatch({
                    type: ACTIONS.UPDATE_PASSWORD_INFO,
                    passwordInfo
                });
            },
            [dispatch]
        )
    };
    const value = { state, actions, dispatch };

    return <GlobalContext.Provider {...{ value, children }} />;
};

export { GlobalContext, GlobalProvider };
